import { jwtDecode } from 'jwt-decode';
import { useState, useRef } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiCamera } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import BASE_URL, { IMAGE_DOMAIN } from '../../config/config';
import CropperModal from './CropperModal';
import useCropper from './useCropper';

const FotoPerfil = ({ editable = true }) => {
    const { t } = useTranslation();
    const token = localStorage.getItem("AuthToken");
    let tokenInfo = {};
    if (token) tokenInfo = jwtDecode(token);

    const [profilePicUrl, setProfilePicUrl] = useState(
        tokenInfo.fotoPerfil
            ? (tokenInfo.fotoPerfil.startsWith('http') ? tokenInfo.fotoPerfil : `${IMAGE_DOMAIN}${tokenInfo.fotoPerfil}`)
            : `${IMAGE_DOMAIN}/images/usuario.png`
    );
    const [uploading, setUploading] = useState(false);
    const fileInputRef = useRef(null);

    const { rawImageSrc, showCropper, crop, setCrop, zoom, setZoom,
        onCropComplete, openCropper, cancelCrop, applyCrop } = useCropper({
        onCropDone: async ({ blob, previewUrl }) => {
            setUploading(true);
            try {
                const fd = new FormData();
                fd.append('fotoPerfil', blob, 'avatar.webp');
                const response = await axios.put(
                    `${BASE_URL}/usuario/actualizar-imagen/${tokenInfo.usuario}`,
                    fd,
                    { headers: { Authorization: token, 'Content-Type': 'multipart/form-data' } }
                );
                if (response.data.success) {
                    setProfilePicUrl(previewUrl);
                    localStorage.setItem("AuthToken", response.data.token);
                    toast.success(t('comun.fotoActualizada'));
                    setTimeout(() => window.location.reload(), 1200);
                } else {
                    toast.error(response.data.message || t('comun.errorActualizarImagen'));
                }
            } catch (err) {
                console.error('Error al actualizar la imagen:', err);
                toast.error(t('comun.errorActualizarImagen'));
            } finally {
                setUploading(false);
            }
        }
    });

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) openCropper(file);
        e.target.value = '';
    };

    return (
        <>
            {editable && showCropper && (
                <CropperModal
                    rawImageSrc={rawImageSrc}
                    crop={crop} setCrop={setCrop}
                    zoom={zoom} setZoom={setZoom}
                    onCropComplete={onCropComplete}
                    onCancel={cancelCrop}
                    onApply={applyCrop}
                />
            )}
            <div className='grid-profile-pic'>
                <img
                    src={profilePicUrl || `${IMAGE_DOMAIN}/images/usuario.svg`}
                    alt={t('comun.fotoPerfil')}
                    className="profile-pic"
                />
                {editable && (
                    <>
                        <button
                            type="button"
                            className="update-profile-pic"
                            onClick={() => fileInputRef.current?.click()}
                            disabled={uploading}
                            title={t('comun.cambiarFotoPerfil')}
                        >
                            {uploading
                                ? <span className="btn-spinner" style={{ borderTopColor: '#fff', width: 14, height: 14 }} />
                                : <FiCamera />}
                        </button>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                        />
                    </>
                )}
            </div>
        </>
    );
};

export default FotoPerfil;